import React from "react";
import { Grid, Typography, Stack, Link, Box, useMediaQuery, Tooltip } from "@mui/material";
import CarouselComp from "./CarouselComp";
import CardElypse from "../../../icons/cardelypse.png";
import PayMethodComponent from "./PayMethodComp";
import { useSelector } from "react-redux";
import { selectPaymentState } from "../sagas/residentpaymentsSlice";
import SpinnerWithNoConfirmation from "../../../shared/Modal/spinnerWithNoConfirmation";
import { AmountTier, FeesDTO, PaymentTypeEnum } from "@inosio/payments-sdk";
import { TieredPricingTable } from "../../../pmui/onboarding/pricingCard";
import HelpIcon from "@mui/icons-material/Help";
import { UNREG_DEBIT_CARD_SPECIFIC } from "../../../utils/constants";

export default function DialogPaymentComp(props: {
  availablePaymentMethods: PaymentTypeEnum[];
  paymentUuid: string;
  setPaymentUuid: React.Dispatch<React.SetStateAction<string>>;
  methods: any;
  setSelectedPayHandler: (fees: number, lastFour: string, uuid: string, tiers?: AmountTier[], rawFeeDTO? : FeesDTO) => void;
  irpPaymentClass?: string;
}) {
  const { availablePaymentMethods, paymentUuid, setPaymentUuid, methods, setSelectedPayHandler } = props;
  return (
    <Grid container>
      <CarouselWrapperRect
        irpPaymentClass={props.irpPaymentClass}
        availablePaymentMethods={availablePaymentMethods}
        paymentUuid={paymentUuid}
        setPaymentUuid={setPaymentUuid}
        data={methods}
        setSelectedPayHandler={setSelectedPayHandler}
      />
    </Grid>
  );
}

const CarouselWrapperRect = (props: {
  availablePaymentMethods: PaymentTypeEnum[];
  paymentUuid: string;
  setPaymentUuid: React.Dispatch<React.SetStateAction<string>>;
  data: any;
  setSelectedPayHandler: (fees: number, lastFour: string, uuid: string, tiers?: AmountTier[]) => void;
  irpPaymentClass?: string;
}) => {
  const { availablePaymentMethods, paymentUuid, setPaymentUuid, data, setSelectedPayHandler } = props;
  let newArray = [];
  let newData = [...data];
  while (newData.length > 0) window.innerWidth > 600 ? newArray.push(newData.splice(0, 3)) :  window.innerWidth > 400 ? newArray.push(newData.splice(0, 2)) : newArray.push(newData.splice(0, 1));

  return (
    <Grid item container>
      <Grid item container sx={{ margin: "0 0 0 0" }}>
        <CarouselComp>
          {newArray.map((each: any, index) => (
            <CarouselSlideRect
              irpPaymentClass={props.irpPaymentClass}
              availablePaymentMethods={availablePaymentMethods}
              paymentUuid={paymentUuid}
              setPaymentUuid={setPaymentUuid}
              newData={each}
              setSelectedPayHandler={setSelectedPayHandler}
              key={index}
            />
          ))}
        </CarouselComp>
      </Grid>
    </Grid>
  );
};

const CarouselSlideRect = (props: {
  availablePaymentMethods: PaymentTypeEnum[];
  paymentUuid: string;
  setPaymentUuid: React.Dispatch<React.SetStateAction<string>>;
  newData: any;
  setSelectedPayHandler: (fees: number, lastFour: string, uuid: string, tiers?: AmountTier[], rawFeeDTO?: FeesDTO) => void;
  irpPaymentClass?: string;
}) => {
  const { paymentUuid, setPaymentUuid, newData, setSelectedPayHandler } = props;
  const { isFetchingPaymentMethods } = useSelector(selectPaymentState);
  // const [paymentMethods, setPaymentMethods] = React.useState<any[]>([]);
  const [showTieredPricingTable, setShowTieredPricingTable] = React.useState({ show: false, level: 0, tiers: [] });
  const isOnMobileScreen = useMediaQuery("(max-width:600px)");

  // // remove unallowed payment methods
  // React.useEffect(() => {
  //   const enumMap: any = {
  //     CC: PaymentTypeEnum.Cc,
  //     DB: PaymentTypeEnum.Db,
  //   };
  //   setPaymentMethods(
  //     newData.filter((data: any) => {
  //       if (data.AccountType) return availablePaymentMethods.includes(PaymentTypeEnum.Ach);
  //       return availablePaymentMethods.includes(enumMap[data.CardType]);
  //     }) ?? []
  //   );
  // }, [availablePaymentMethods, setPaymentMethods, newData]);

  const handlePaymentMethodClicked = React.useCallback((method: any) => {
    method && setSelectedPayHandler(method?.feeAmount, method?.AccountLastFour, method?.Uuid, method?.tiers, method?.rawFeeDTO);
  }, []);

  // retain card selection
  React.useEffect(() => {
    paymentUuid && setPaymentUuid(paymentUuid);
  }, [paymentUuid, setPaymentUuid]);

  return (
    <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} style={{ height: "230px" }} position={"relative"}>
      <Box
        sx={{
          width: "220px",
          height: "max-content",
          position: "absolute",
          top: "5%",
          left: `${+showTieredPricingTable.level + 1}%`,
          zIndex: "9",
          background: "#ffffff",
          border: "2px solid #eeeeee",
          borderRadius: "5px",
          display: showTieredPricingTable.show ? undefined : "none",
        }}
      >
        <TieredPricingTable tiers={showTieredPricingTable.tiers} />
      </Box>
      {isFetchingPaymentMethods ? (
        <SpinnerWithNoConfirmation />
      ) : (
        newData.map((method: any, index: number) => {
          const fee = method?.feeAmount;
          const isDbCardProcessingAsCc = method.CardType === 'DB' && method.ProcessAsCardType=== 'CC';

          //few scenarios here. 1) It's not tiered and it's PM incurred.... or 2) it's tiered, and EVERY tier is PM incurred. Else false.
          const isCompletelyPmIncurred = !!((method?.tiers?.length && method?.tiers.every((tf: { PaidBy: string; })=>tf.PaidBy==='P')) || (method.PaidBy==='P' && !method?.tiers.length ));
          const payMethodConfig = {
            method,
            paymentUuid,
            CardElypse,
            setPaymentUuid,
            handlePaymentMethodClicked,
            newData,
            baseMethodParams: { height: "164px", width: "116px", border: "", borderRadius: "0" },
            clickedMethodParams: { height: "184px", width: "131px", border: "3px solid #39A2DB", borderRadius: "10px" },
            disabled: method.Disabled,
          };
          return (
            <div style={{ marginTop: "10px" }} key={index}>
              {method?.AccountType === "C" || method?.AccountType === "S" ? <PayMethodComponent {...payMethodConfig} isBankAccount /> : method?.CardType && <PayMethodComponent {...payMethodConfig} />}
              <Typography id="card-fee">
                {/* check if irp class is VAP and TP is configured on property */}
                {
                isCompletelyPmIncurred? (<>Free</>):
                method?.tiers?.length && props.irpPaymentClass === "VAP" ? (
                  <Link
                    onMouseEnter={
                      isOnMobileScreen
                        ? undefined
                        : (event: React.SyntheticEvent) => {
                            setShowTieredPricingTable({ show: true, level: +(index % 3) * 25, tiers: method.tiers }); // smart maneuver for positioning tiered pricing table
                          }
                    }
                    onMouseLeave={(event: React.SyntheticEvent) => {
                      setShowTieredPricingTable({ show: false, level: 0, tiers: [] });
                    }}
                    // on mobile screens
                    onTouchStartCapture={(event: React.SyntheticEvent) => {
                      setShowTieredPricingTable({ show: true, level: +(index % 3) * 25, tiers: method.tiers }); // smart maneuver for positioning tiered pricing table
                    }}
                  >
                    View Fees{isDbCardProcessingAsCc && 
                  <Tooltip leaveTouchDelay={5000} enterTouchDelay={0} title={UNREG_DEBIT_CARD_SPECIFIC} placement="bottom">
                  <HelpIcon sx={{ fontSize: 17, color: "#C4C4C4", cursor: "pointer" }} />
                  </Tooltip>}
                  </Link>
                ) : (
                  <>Fees: ${fee / 100}
                  {isDbCardProcessingAsCc && 
                  <Tooltip leaveTouchDelay={5000} enterTouchDelay={0} title={UNREG_DEBIT_CARD_SPECIFIC} placement="bottom">
                  <HelpIcon sx={{ fontSize: 17, color: "#C4C4C4", cursor: "pointer" }} />
                  </Tooltip>}
                  </>
                  
                )}
              </Typography>
            </div>
          );
        })
      )}
    </Stack>
  );
};
